/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';
import { GenericFinderDialogConfig } from '../../resources/generic-finder.model';
import { GenericFinderGridDefinition } from './generic-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-generic-finder-dialog',
  templateUrl: 'generic-finder-dialog.component.html',
  styleUrls: ['generic-finder-dialog.component.scss'],
  providers: [GenericFinderGridDefinition],
})
export class GenericFinderDialogComponent
  extends AbstractFinderDialogComponent<GenericFinderDialogConfig, any>
  implements OnInit {

  getId: TransformFn<any, ID>;
  defaultTitle: string;
  dataSourceFactory: (name: string, filter?: any) => SlicedDataSource<any>;

  form: FormState<any>;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              public gridDefinition: GenericFinderGridDefinition,
              private translations: TranslationService,
              formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: { name: void 0 },
    });
  }

  ngOnInit(): void {
    const { getId, defaultTitle, dataSourceFactory } = getDialogInitData(this.dialogData);

    this.getId = getId;
    this.defaultTitle = defaultTitle;
    this.dataSourceFactory = dataSourceFactory;

    super.ngOnInit();
  }

  protected buildDataSource(): SlicedDataSource<any> {
    return this.dataSourceFactory(getControlValue(this.form.group, 'name'), this.input.filter);
  }
}
